import type { ReactNode } from "react";

export interface EmojiRendererWrapperProps {
  children: ReactNode;
  isWrapperElementClickable?: boolean;
  wrapperClassName?: string;
}

export const EmojiRendererWrapper = ({
  isWrapperElementClickable,
  wrapperClassName,
  children,
}: EmojiRendererWrapperProps) => {
  if (isWrapperElementClickable) {
    return (
      <button type="button" className={wrapperClassName}>
        {children}
      </button>
    );
  }
  if (wrapperClassName) {
    return <div className={wrapperClassName}>{children}</div>;
  }

  return <>{children}</>;
};
